import { useState, useEffect } from 'react';
import config from '../../config/config';
import { Link } from 'react-router-dom';
import Header from '../directives/header';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import '../css/home.css';
import Footer from '../directives/footer';
import GetInTouch from './getInTouch';
import LatestBlogs from './latestBlogs';
import ModalDeck from './modalDeck';
import LatestPress from './latestPress';
import Modal from 'react-bootstrap/Modal';
import { getHomeBannerData } from '../../apis/apiAction';

const Home = () => {
  // -----------
  const [show, setShow] = useState(false);
  const [BannerData, setBannerData] = useState([]);

  useEffect(() => {
    getBannerData();
  }, []);

  const getBannerData = async () => {
    try {
      let res = await getHomeBannerData();

      if (res.data) {
        setBannerData(res.data);
      }
    } catch (error) {
      console.error('Error fetching banner data:', error);
    }
  };

  const handleDeck = (e) => {
    e.preventDefault();
    try {
      window.location.href = 'https://docsend.com/v/khq29/deck';
    } catch (error) {
      console.log('Err', error);
    }
  };

  return (
    <>
      <Header />
      <section className="herobanner position-relative">
        <div className="bg-herobanner position-absolute top-0 bottom-0 start-0 end-0 w-100">
          <img
            src="assets/images/banner/banner.png"
            className="w-100 h-100 object-fit-cover"
            alt=""
          />
        </div>
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={7} className="pt-5 mb-4">
              <div className="bannerContent">
                <h1 className="text-uppercase fw-bold text-white">
                  {BannerData.heroBannerFirstHeading}{' '}
                  <div className="text-primary your_reach">{BannerData.heroBannerSecondHeading}</div>
                </h1>

                {/* <div className="mt-4">
                  <img src="assets/images/logo/utxName.svg" className="" />
                </div> */}
                <p className="my-4">{BannerData.heroBannerDescription}</p>
              </div>
              <div>
                <Button
                  as={Link}
                  to={`${config.baseUrl}ourstrategy`}
                  variant="primary-gradient"
                  className="border-0 text-capitalize fw-normal me-1"
                >
                  Learn More about our Strategy
                </Button>

                <Button
                  as={Link}
                  to={`${config.baseUrl}unitronixexplained`}
                  variant="default"
                  className="border-0 fw-semibold me-1 text-white"
                >
                  What is UTRX?{' '}
                  <span className="ms-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M4 12.4789H20M20 12.4789L14 18.4789M20 12.4789L14 6.47894"
                        stroke="#61C19B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </Button>

                <Button
                  variant="default"
                  className="border-0 fw-semibold text-white"
                  onClick={() => setShow(true)}
                >
                  The UTRX Deck
                  <span className="ms-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M6 18.4789L18 6.47894M18 6.47894H10M18 6.47894V14.4789"
                        stroke="#61C19B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </Button>
              </div>
            </Col>
            <Col lg={5} className="pt-5 mb-4 text-center">
              <div className="bannerImage">
                <img src="assets/images/utx.gif" className="w-100" alt="" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <LatestBlogs />
      <section className="investment py-0">
        <Container>
          <Row>
            <Col lg={12} className="mb-4">
              <div className="heading my-4">
                <h1 className="text-white fw-normal">
                  Made for mass adoption
                </h1>
              </div>
            </Col>
            <Col lg={12} className="mb-5">
              <Card className="greenCard">
                <Card.Body className="pb-0 ">
                  <div>
                    <Row className="align-items-center">
                      <Col lg={6} className="">
                        <div>
                          <img src="assets/images/investment.png" alt="" />
                        </div>
                      </Col>
                      <Col lg={1} className=""></Col>
                      <Col lg={4} className="">
                        <div className="featureContent">
                          <h1 className="fw-semibold text-white">
                            {BannerData.massAdoptionHeading}
                          </h1>
                          <p className="my-4">
                            {BannerData.massAdoptionDescription}
                          </p>
                          <Button
                            variant="outline-white"
                            className="border"
                            href={`${config.baseUrl}howitwork#safer`}
                          >
                            Find Out More
                          </Button>
                        </div>
                      </Col>
                      <Col lg={1} className=""></Col>
                    </Row>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mb-4">
              <Card className="blueCard">
                <Card.Body className="p-0">
                  <div>
                    <div className="p-4 z-1">
                      <h2 className="my-2 text-white">Real World use Cases</h2>
                      <p className="small my-4">
                        {BannerData.realWorldUseDescription}
                      </p>
                      <Button
                        variant="outline-white"
                        className="border"
                        href={`${config.baseUrl}howitwork#real-world-case-study`}
                      >
                        Read more
                      </Button>
                    </div>
                    <div className="blogImg text-end">
                      <img
                        src="assets/images/realworld.png"
                        className="w-85 object-fit-contain"
                        alt=""
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6} className="mb-4">
              <Card className="blueCard">
                <Card.Body className="p-0">
                  <div>
                    <div className="p-4 z-1">
                      <h2 className="my-2 text-white">Unitronix Roadmap</h2>
                      <p className="small my-4">
                        {BannerData.unitronixRoadmapDiscription}
                      </p>
                      <Button
                        as={Link}
                        to={`${config.baseUrl}roadmap`}
                        variant="outline-white"
                        className="border"
                        target="0"
                      >
                        Explore further
                      </Button>
                    </div>
                    <div className="blogImg text-end">
                      <img
                        src="assets/images/unitronixroadmap.png"
                        className="w-85 object-fit-contain "
                        alt=""
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="matrix py-0">
        <Container>
          <Row>
            <Col lg={12} className="mb-4">
              <div className="heading my-4">
                <h1 className="text-white fw-normal">
                  Designed for real world use
                </h1>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <div className="matrixBox position-relative overflow-hidden mb-4">
            <div className="bgImg position-absolute start-0 end-0 top-0 bottom-0">
              <img
                src="assets/images/utxvideo.gif"
                width={`100%`}
                height={`500px`}
                style={{ opacity: '0.5' }}
                alt=""
              />
            </div>
            <Row>
              <Col lg={12} className="">
                <Card className="bg-transparent">
                  <Card.Body className="pb-0 ">
                    <Row
                      className="justify-content-center align-items-center"
                      style={{ minHeight: '482px' }}
                    >
                      <Col lg={7}>
                        <div className="text-center">
                          <div className="">
                            <img src="assets/images/logo/utxName.svg" alt="" />
                          </div>
                          <h1 className="mb-0 text-white fw-bold">
                            {BannerData.realWorldHeading}
                          </h1>
                          <p className="fw-light">
                            {BannerData.realWorldDescription}
                          </p>
                          <Button variant="primary" className="text-black">
                            Coming Soon
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="buildgrowth py-0">
        <Container>
          <Row>
            <Col lg={12} className="mb-4">
              <div className="heading my-4">
                <h1 className="text-white fw-normal">Build for growth</h1>
              </div>
            </Col>
            <Col lg={12} className="mb-5">
              <Card>
                <Card.Body className="p-0 ">
                  <div>
                    <Row className="align-items-center">
                      <Col lg={6} className="">
                        <div>
                          <img
                            src="assets/images/buidgrowth.svg"
                            className="w-100"
                            alt=""
                          />
                        </div>
                      </Col>
                      <Col lg={1} className=""></Col>
                      <Col lg={5} className="">
                        <div className="featureContent p-4">
                          <h1 className="fw-semibold text-white mb-4">
                            {BannerData.buildGrowthDescription}
                          </h1>
                          <Button
                            as={Link}
                            to="https://discord.gg/unitronix"
                            variant="outline-white"
                            className="border"
                            target="0"
                          >
                            Join Our Community
                          </Button>
                        </div>
                      </Col>
                      <Col lg={1} className=""></Col>
                    </Row>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <LatestPress />
      <GetInTouch message={BannerData.companyGoalHeading} />

      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="border"
        centered
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="p-4">
          <ModalDeck
            onSuccess={() => {
              setShow(false);
              handleDeck(new Event('click'));
            }}
          />
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};
export default Home;
